const heroBodyText =
  'Card products represent the behavior and functionality of one or more cards (either physical or virtual). You can view the card product controls to understand how their associated cards are used. You can also create new cards with card products.';
const docsLink = 'https://www.marqeta.com/docs/core-api/card-products';

export { heroBodyText, docsLink };
